var map = {
	"./icon1.png": "L0md",
	"./icon2.png": "bHdY",
	"./icon3.png": "aQaA",
	"./icon4.png": "zZUQ",
	"./icon5.png": "WUGy",
	"./icon6.png": "/07+",
	"./icon7.png": "H9bh",
	"./icon8.png": "Y04f"
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) // check for number or string
		throw new Error("Cannot find module '" + req + "'.");
	return id;
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "OiXX";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/active/sakura/sanliouLinkage/lottery/winning ^\.\/icon.*\.png$
// module id = OiXX
// module chunks = 6